import { Orient } from '@src/slide/application/service/snap-line-service/interface/orient.interface';
import React, { Component } from 'react';
import { DotLine } from '@src/slide/application/service/snap-line-service/render/components/extend-line/dot-line';
import { IBaseUIProps } from '@src/slide/application/service/snap-line-service/interface/render.interface';

export interface IExtendLineProps extends IBaseUIProps {
    orient: Orient;
    range: [number, number];
    position: number;
}
/**
 * 辅助线
 */
export class ExtendLine extends Component<IExtendLineProps> {
    private extendLineColor = '#b2b2b2';
    public render() {
        const { range, position, orient } = this.props;
        const lineLength = range[1] - range[0];
        const rect = orient === Orient.HORIZONTAL ? {
            width: lineLength,
            height: this.props.strokeWidth,
            left: range[0],
            top: position,
        } : {
            width: this.props.strokeWidth,
            height: lineLength,
            left: position,
            top: range[0],
        };
        return <DotLine
            rect={rect}
            orient={orient}
            color={this.extendLineColor}
            scale={this.props.scale}
            strokeDash={this.props.strokeDash}
        />;
    }
}
